import React, { memo } from 'react';
import styled from 'styled-components';
import CardBody from '@minecraft.card-body';
import { media } from '@minecraft.themes';
import { gqlMediaTypeCodeEnum as MEDIA_TYPE } from '@minecraft.graphql-types';
import TalentCardMenu from '../TalentCardMenu';
import TalentCardPhoto from '../TalentCardPhoto';
import TalentCardInfo from '../TalentCardInfo';

export const StyledCustomCardBody = styled(CardBody)`
  padding: 1rem;
  padding-bottom: 0.5rem;
  position: relative;
  text-align: left;
  display: flex;
  flex-direction: row;

  ${media.sm`
    flex-direction: column;
    align-items: center;
  `}
`;

const TalentCardBody = ({
  skipRepsShortCodes,
  isPublic,
  isCustomized,
  isFastCastProfile,
  isPersonalProfile,
  profileId,
  roleId,
  roleName: primaryRoleName,
  profileMinor,
  profileGuid,
  profileStageName,
  snapshotKey,
  profilePhoto,
  profileMainDivision,
  profileMainOrganizationName,
  profileMainDivisionName,
  profileTalentUnions,
  profileDateOfBirth,
  submissionHasAddInNote,
  menuSettings,
  thumbnailCropSettings,
  tooltipPlacement,
  thumbnailSize,
  handleDeleteModalToggle,
  handleViewAddInNotesModalOpen,
  handleEditAddInNotesModalOpen,
  className,
  roleGuid,
  projectGuid,
  handleReorder,
  handleRoleNameEdit,
  renderContactInfo,
  viewOnly = false,
}) => {
  return (
    <StyledCustomCardBody className={className}>
      {!viewOnly && (
        <TalentCardMenu
          isFastCastProfile={isFastCastProfile}
          isSubmissionCustomized={isCustomized}
          submissionHasAddInNote={submissionHasAddInNote}
          profileId={profileId}
          guid={profileGuid}
          roleId={roleId}
          roleGuid={roleGuid}
          projectGuid={projectGuid}
          handleDeleteSubmission={handleDeleteModalToggle}
          handleViewAddInNotesModalOpen={handleViewAddInNotesModalOpen}
          handleEditAddInNotesModalOpen={handleEditAddInNotesModalOpen}
          menuSettings={menuSettings}
          snapshotKey={snapshotKey}
          isPublic={isPublic}
          handleReorder={handleReorder}
          isVideoSnapshot={profilePhoto?.mediaType?.code === MEDIA_TYPE.VIDEO}
        />
      )}
      <TalentCardPhoto
        profilePhoto={profilePhoto}
        thumbnailSize={thumbnailSize}
        thumbnailCropSettings={thumbnailCropSettings}
      />
      <TalentCardInfo
        skipRepsShortCodes={skipRepsShortCodes}
        isFastCastProfile={isFastCastProfile}
        isPersonalProfile={isPersonalProfile}
        primaryRoleName={primaryRoleName}
        profileId={profileId}
        profileMinor={profileMinor}
        profileStageName={profileStageName}
        profileMainDivision={profileMainDivision}
        profileMainOrganizationName={profileMainOrganizationName}
        profileMainDivisionName={profileMainDivisionName}
        profileTalentUnions={profileTalentUnions}
        profileDateOfBirth={profileDateOfBirth}
        tooltipPlacement={tooltipPlacement}
        handleRoleNameEdit={!viewOnly && handleRoleNameEdit}
        renderContactInfo={renderContactInfo}
      />
    </StyledCustomCardBody>
  );
};

export default memo(TalentCardBody);
